import { Tabs as MuiTabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GREEN_BASIC } from '../../common-styles/color-palette';

export const Tabs = styled(MuiTabs)({
    '& .MuiTabs-indicator': {
        backgroundColor: GREEN_BASIC,
    }
});
